import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { API_BASE_URL, API_ENDPOINTS } from './config'
import i18n from './locales'

// 将API配置添加为Vue原型属性，方便在所有组件中使用
Vue.prototype.$api = {
  baseUrl: API_BASE_URL,
  endpoints: API_ENDPOINTS
}

Vue.config.productionTip = false

new Vue({
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
